import { Box, Icon, InputAdornment, Typography } from '@mui/material'
import AdxInput from 'components/custom/AdxInput'
import React from 'react'
import { useQuery } from 'react-query'
import { getOvertimeRate } from 'services/api/modules/payroll/payroll-config/overtimeConfigApi'
import OvertimeModal from './OvertimeModal'
import RemoveOvertimeModal from './RemoveOvertimeModal'
import AdxButton from 'components/custom/AdxButton'

const OvertimeComponent = ({ selectValue, data }) => {
  let time_id = parseInt(data?.time_id)
  const {
    // isLoading: loadingOvertimeConfig,
    data: overtimeRate,
  } = useQuery('getOvertimeRate', async () => {
    const { data } = await getOvertimeRate()
    let customData = data?.data?.categories
    return customData
  })

  return (
    <Box>
      {selectValue &&
        (selectValue?.overtime?.overtime_items.length === 0 ? (
          <Box width="200px">
            <OvertimeModal
              employeeOvertime={selectValue?.overtime}
              customOvertime={overtimeRate}
              time_id={time_id}
              employee_id={selectValue?.id}
            >
              <AdxButton variant={'ghost'} sx={{ textDecoration: 'underline' }}>
                Add overtime
              </AdxButton>
            </OvertimeModal>
          </Box>
        ) : (
          <Box display="flex" alignItems="flex-start" columnGap={2} width="100%">
            <Box>
              <AdxInput
                label={<Typography variant="subtitle2">Total overtime hours</Typography>}
                disabled
                sxLabel={{
                  color: 'light-gray-text.main',
                }}
                sxInput={{
                  color: 'light-gray-text.main',
                  backgroundColor: 'white.main',
                }}
                value={selectValue?.overtime.total_hours}
                endAdornment={<InputAdornment position="end">hours</InputAdornment>}
              />
            </Box>
            <Box>
              <AdxInput
                label={<Typography variant="subtitle2">Amount</Typography>}
                startAdornment={<InputAdornment position="start">RM</InputAdornment>}
                disabled
                sxLabel={{
                  color: 'light-gray-text.main',
                }}
                sxInput={{
                  color: 'light-gray-text.main',
                  backgroundColor: 'white.main',
                }}
                value={selectValue?.overtime.total_value}
              />
            </Box>
            <Box display="flex" alignItems="flex-end" height="70px">
              <OvertimeModal
                employeeOvertime={selectValue?.overtime}
                customOvertime={overtimeRate}
                time_id={time_id}
                employee_id={selectValue?.id}
              >
                <AdxButton variant={'ghost'} sx={{ textDecoration: 'underline' }}>
                  Edit
                </AdxButton>
              </OvertimeModal>
              <RemoveOvertimeModal employee_id={selectValue?.id} time_id={time_id}>
                <Icon sx={{ color: 'error.main', mb: 0.5, cursor: 'pointer' }}>remove_circle</Icon>
              </RemoveOvertimeModal>
            </Box>
          </Box>
        ))}
    </Box>
  )
}

export default OvertimeComponent
